import React, { useEffect, useState } from "react";
import CashfuseChart from "./Common/graph/CashfuseChart";
import SubHeaderMenu from "./Sidebar/SubHeaderMenu";
import { useLocation } from "react-router-dom";
import Button from "./Common/Button";
import CustomerGraph from "./Common/graph/CustomerGraph";
import Dropdown from "./Common/Dropdown";
import DashbordCard from "./Common/Cards/DashbordCard";
import usericon from "../assets/images/dashboardImg/usericon.svg";
import industryicon from "../assets/images/dashboardImg/Industryicon.svg";
import marchantsicon from "../assets/images/dashboardImg/marchanticon.svg";
import statusicon from "../assets/images/dashboardImg/Statusicon.svg";
import { Table } from "./Common/Table/Table";
import useNetworkServices from "../Networking/baseAPIManager";
import NoDataFound from "./Common/NoDataFound";
import Modal from "./Common/Modal ";
import Loader from "./Common/Loader";

const Dashboard = () => {
  const { Dashboard, queryUpdate } = useNetworkServices();
  const [loading, setLoading] = useState(false);
  const date = new Date();
  const currentMonth = new Date()
    .toLocaleString("default", { month: "long" })
    .toLowerCase();
  const currentYear = date.getFullYear();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [dashboardData, setDashboardData] = useState({});
  const [viewData, setViewData] = useState({});
  const [open, setOpen] = useState(false);

  const yearOptions = Array.from({ length: 5 }, (_, i) => ({
    name: `${currentYear - i}`,
    value: `${currentYear - i}`,
  }));
  let currentMonthName = currentMonth.slice(0, 3);
  let monthName = currentMonthName.charAt(0).toUpperCase() + currentMonthName.slice(1);
  const monthOptions = [
    // { name: monthName, value: currentMonth },
    { name: "Jan", value: "january" },
    { name: "Feb", value: "february" },
    { name: "Mar", value: "march" },
    { name: "Apr", value: "april" },
    { name: "May", value: "may" },
    { name: "Jun", value: "june" },
    { name: "Jul", value: "july" },
    { name: "Aug", value: "august" },
    { name: "Sep", value: "september" },
    { name: "Oct", value: "october" },
    { name: "Nov", value: "november" },
    { name: "Dec", value: "december" },
  ];
  const cards = [
    {
      icon: marchantsicon,
      iconContainer: "#FFE9E6",
      title: "Total Merchants",
      content: dashboardData.merchant || 0,
      path: "/marchant_overview",
    },
    {
      icon: usericon,
      iconContainer: "#FFE6AB",
      title: "Total Users",
      content: dashboardData.user || 0,
      path: "/customer_list",
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF",
      title: "Total Industries",
      content: dashboardData.category || 0,
      path: "/industry_management",
    },
    {
      icon: statusicon,
      iconContainer: "#F8BAC8",
      title: "KYC Status",
      content: dashboardData.kyc || 0,
      path: "/kyc_verification",
    },
  ];

  const getDashboardData = async () => {
    const params = { month: selectedMonth, year: selectedYear };

    setLoading(true);
    try {
      const response = await Dashboard(params);
      setDashboardData(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateEnquiry = (enquiryId) => {
    const id = `?id=${enquiryId}`;

    try {
      const response = queryUpdate(id);
      console.log("Enquiry updated successfully", response);
      getDashboardData();
    } catch (error) {
      console.error("Error updating enquiry:", error);
    }
  };

  const columns = [
    { header: "Name", accessor: "fullName" },
    { header: "Email Address", accessor: "email" },
    { header: "Phone", accessor: "mobile" },
    { header: "City", accessor: "city" },
    { header: "State", accessor: "state" },
    { header: "Subject", accessor: "subject" },
    {
      header: "Message",
      accessor: "message",
      customBtn: (data) => (
        <Button
          type="button"
          label="View"
          className="text-[#025D89]"
          onClick={() => {
            setViewData(data);
            setOpen(true);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth, selectedYear]);

  return (
    <div id="main" className="px-4 sm:px-6 lg:px-8">
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <SubHeaderMenu location={useLocation()} />
      </h1>

      {/* Cards Section */}
      <div className="flex justify-between border-[1px] border-[#DAE3F8] w-full h-auto p-4 gap-5 mb-5 rounded-md">
        <DashbordCard card={cards} iconClass="rounded-lg" />
      </div>

      {/* Graph Section */}
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-12">
        <div className="col-span-12 lg:col-span-6 p-4 border border-[#DAE3F8] rounded-lg">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-bold text-gray-800 mb-1">Summary</h3>
            <Dropdown
              id="year"
              name="year"
              value={selectedYear}
              option={yearOptions}
              onChange={(e) => setSelectedYear(e.target.value)}
              SelectClass="w-full md:w-24 h-8 border border-[#DAE3F8] rounded-md p-1 focus:outline-none"
              optionClass=""
            />
          </div>
          <div className="mt-4">
            <CashfuseChart data={dashboardData} />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6 p-4 border border-[#DAE3F8] rounded-lg">
          <div className="flex justify-between items-center">
            <h6 className="text-sm font-bold text-gray-600 mb-2">
              All Requests
            </h6>
            <Dropdown
              id="month"
              name="month"
              value={selectedMonth}
              option={monthOptions}
              onChange={(e) => setSelectedMonth(e.target.value)}
              SelectClass="w-full md:w-28 h-8 border border-[#DAE3F8] rounded-md p-1 focus:outline-none"
            />
          </div>
          <div className="flex flex-col md:flex-row gap-2 pt-4">
            <div className="w-full md:w-1/2 border border-[#DAE3F8] xl:p-2">
              <p className="text-[#0B1C33] text-center pt-4">Card Approval</p>
              {dashboardData.OfferData?.length ? (
                <CustomerGraph offerData={dashboardData.OfferData} />
              ) : (
                <NoDataFound />
              )}
            </div>
            <div className="w-full md:w-1/2 border border-[#DAE3F8] xl:p-2">
              <p className="text-[#0B1C33] text-center pt-4">Banner Status</p>
              {dashboardData.BannerData?.length ? (
                <CustomerGraph bannerData={dashboardData.BannerData} />
              ) : (
                <NoDataFound />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Enquiry Table Section */}
      <h4 className="pt-4 text-lg text-gray-700 font-bold">Recent Enquiries</h4>

      <div className="border-[1px] border-[#DAE3F8] w-full  p-4 mt-5 rounded-md">
        <Table
          columns={columns}
          data={dashboardData.UserEnquiry || []}
          tableClass="h-auto"
        />
      </div>

      {/* Modal Section */}
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Message"
        Classes=" w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 h-auto"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-8 py-6 text-gray-700">
          <div className="flex flex-col gap-6">
            <p>
              <strong>Name :</strong> {viewData.fullName || "N/A"}
            </p>
            <p>
              <strong>Phone :</strong> {viewData.mobile || "N/A"}
            </p>
            <p>
              <strong>State :</strong> {viewData.state || "N/A"}
            </p>
          </div>
          <div className="flex flex-col gap-6">
            <p>
              <strong>Email :</strong> {viewData.email || "N/A"}
            </p>
            <p>
              <strong>Subject :</strong> {viewData.subject || "N/A"}
            </p>
            <p>
              <strong>City :</strong> {viewData.city || "N/A"}
            </p>
          </div>
        </div>
        <h4 className="px-8 pt-4 text-lg text-gray-700 font-bold ">Message</h4>
        <div className="p-6 mx-8 bg-gray-50 rounded-lg border border-gray-200 shadow-md overflow-auto break-words">
          <p className="text-sm text-gray-600">
            {viewData.message || "No message available"}
          </p>
        </div>
        <div className="px-8 py-6 flex justify-center">
          <Button
            type="button"
            className="px-6 py-2 bg-[#025D89] hover:bg-[#025c89c4] text-white rounded-md text-sm transition-all duration-150"
            label="Mark"
            onClick={() => {
              setOpen(false);
              updateEnquiry(viewData._id);
            }}
          />
        </div>
      </Modal>
      {loading && <Loader />}
    </div>
  );
};

export default Dashboard;
